import React from 'react';

class ProjectInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { details } = this.props;
        return (
            <section className="mole__project--info fulLW">
                <div className="main-container">
                    <div className="inner-container">
                        <h2 className="font-lg">{details.post_title}</h2>

                        <article className="--caption font-lg w-100 c-general">
                            {details.project_sub_heading}
                        </article>

                        <a href="javascript:" class="mb-0 font-md d-inline-flex justify-content-center align-items-center open-modal btn--projectInfo hide">
                        <span>Project Information</span>
                            <svg enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 50 50">
                                <circle cx="25" cy="25" fill="none" r="24" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                <rect fill="none" height="50" width="50"/>
                                <path d="M23.779,16.241c-0.216,0-0.357-0.144-0.357-0.359v-2.618c0-0.215,0.142-0.359,0.357-0.359h2.439  c0.215,0,0.359,0.144,0.359,0.359v2.618c0,0.215-0.145,0.359-0.359,0.359H23.779z M23.852,37.293c-0.215,0-0.358-0.143-0.358-0.358  V20.473c0-0.215,0.144-0.359,0.358-0.359h2.295c0.216,0,0.359,0.144,0.359,0.359v16.462c0,0.216-0.144,0.358-0.359,0.358H23.852z"/>
                            </svg>
                        </a>

                    </div>
                </div>
            </section>    
        );
    }
}
export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/ProjectInfo.js